// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select_wrapper__2qZex","input":"select_input__3xK_t","label":"select_label__3plu5","error":"select_error__hVKfS"};